// Ponto de entrada do BUNDLE de navegador (o que vira `cdn.synqi3.ai/sdk/v2/synqi3.min.js`).
//
// Existe separado do `index.js` porque tem um efeito colateral: ao ser carregado, ele se
// auto-inicializa a partir da tag `<script>`. O `index.js` continua puro, para quem importa o
// pacote num bundler e monta o `Tracker` na mão.
//
// O ciclo roda o quanto antes: a decisão guardada é aplicada de forma SÍNCRONA, e cada milissegundo
// aqui é milissegundo a mais de chance de aplicar antes da primeira pintura. Se o documento ainda
// está sendo lido, esperamos o DOM ficar pronto — antes disso os elementos de slot não existem, e
// aplicar em elemento inexistente não é "mais cedo", é não aplicar.
import { autoIniciar } from "./browser.js";

function _partir() {
  try {
    autoIniciar(document);
  } catch {
    /* nunca derruba a página de quem nos hospeda */
  }
}

if (typeof document !== "undefined" && document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", _partir, { once: true });
} else {
  _partir();
}
